import React from "react";
import { Provider } from "react-redux";
import { Router, Route } from "react-router-dom";
import { createFirestoreInstance } from "redux-firestore";
import { ReactReduxFirebaseProvider } from "react-redux-firebase";

import { firebase } from "./firebase";
import store from "./redux/store";
import Routes from "./routing/Routes";
import Layout from "./components/layout/Layout";
import history from "./history";

const rrfConfig = {
  useFirestoreForProfile: true,
  userProfile: "users",
  attachAuthIsReady: true,
};

const rrfProps = {
  firebase,
  config: rrfConfig,
  dispatch: store.dispatch,
  createFirestoreInstance,
};

const App = () => {
  return (
    <Provider store={store}>
      <ReactReduxFirebaseProvider {...rrfProps}>
        <Router history={history}>
          <Layout>
            <Route component={Routes} />
          </Layout>
        </Router>
      </ReactReduxFirebaseProvider>
    </Provider>
  );
};

export default App;
